import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Container, Row, Col, Hidden } from "react-grid-system";
import { SectionHeader, MarkdownGenerator, Video } from "./../Blocks.js";
import Section from "./Section.js";
import { Link } from "react-router-dom";

import SVG_Icon_1 from "./img/e-commerce.svg";
import SVG_Icon_2 from "./img/place.svg";
import SVG_Icon_3 from "./img/exchange.svg";

import IMG_MOOD from "./photos/Mood-Photo.jpg";

import STEP_1video from "./photos/step1.mp4";
import STEP_2video from "./photos/step2.mp4";
import STEP_3video from "./photos/step3.mp4";

import STEP_1fallback from "./photos/Es-ist-so-einfach1.jpg";
import STEP_2fallback from "./photos/Es-ist-so-einfach2.jpg";
import STEP_3fallback from "./photos/Es-ist-so-einfach3.jpg";

class Carousel extends React.Component {
  static Container = styled.div`
    .slide {
      position: absolute;
      top: 0;
      left: 0;
      cursor: pointer;
      transition: opacity 2s ease;
      top: 50%;
      left: 50%;
      height: 100%;
      width: 100%;
      transform: translate(-48%, -48%);
    }
    .slide-hide {
      opacity: 0;
    }
  `;
  state = {
    index: 0,
  };
  _timer = null;
  timeoutFn = () => {
    this.next();
    this.startTimer();
  };
  next() {
    const max = this.props.images.length - 1;
    let index = this.state.index + 1;
    index = index < 0 ? max : index;
    index = index > max ? 0 : index;
    this.setState({
      index,
    });
  }
  onImageClick = () => {
    // console.log("!mi");
    this.next();
    this.cancelTimer();
    this.startTimer();
  };
  startTimer() {
    this._timer = setTimeout(this.timeoutFn, 8000);
  }
  cancelTimer() {
    clearTimeout(this._timer);
  }
  componentDidMount() {
    this.startTimer();
  }
  componentWillUnmount() {
    this.cancelTimer();
  }
  render() {
    return (
      <Carousel.Container className="mb3">
        {this.props.images.map((url, index) => {
          return (
            <Video
              key={index}
              enabled={this.props.contentEnabled && index === this.state.index}
              imageClassName="fit"
              src={url}
              poster={this.props.poster[index]}
              onClick={this.onImageClick}
            />
          );
        })}
      </Carousel.Container>
    );
  }
}

const CIRCLE_RADIUS = 2;
const CIRCLE_LEFT_OFFSET = -2.5;
const CIRCLE_TOP_OFFSET = -0.42;

const Circle = styled.div.attrs({
  className:
    "absolute flex items-center justify-center color-navy h5 font-regular",
})`
  left: ${CIRCLE_LEFT_OFFSET}rem;
  top: ${CIRCLE_TOP_OFFSET}rem;
  width: 0;
  //
  border-radius: 50%;
  width: ${CIRCLE_RADIUS}rem;
  height: ${CIRCLE_RADIUS}rem;
`;

const Markdown = MarkdownGenerator({
  className: "body line-height-5 color-bg",
});

const renderUsageSteps = data =>
  data.map((p, index, arr) => {
    return (
      <li key={index} className="relative mt4">
        <Circle>{index + 1}</Circle>
        <h3 className="h5 font-regular color-navy mb2 mt3">{p.title}</h3>
        <p className="h6 mb3 font-light color-bg line-height-5">{p.body}</p>
      </li>
    );
  });

const renderServiceStep = ({ icon, title, body }) => {
  const handleClick = event => {
    const _attr = event.target.getAttribute("href");
    if (_attr != null) {
      if (_attr.indexOf("/") !== 0) {
        event.preventDefault();
        window.open(_attr);
      }
    }
  };

  return (
    <Col
      className="center mt4 mmt1"
      sm={8}
      md={3}
      offset={{ sm: 2, md: 3 / 4 }}
    >
      <Hidden xs sm>
        <img className="mb3" src={icon} width={96} alt="" />
      </Hidden>
      <h3 className="h5 my3 mmb1 color-navy font-regular line-height-4">
        {title}
      </h3>
      <div onClick={handleClick}>
        <Markdown>{body}</Markdown>
      </div>
    </Col>
  );
};

export default class SectionTutorial extends React.Component {
  static contextTypes = {
    copy: PropTypes.object,
  };
  $el = React.createRef();
  render() {
    const copy = this.context.copy.get("SectionTutorial");
    return (
      <Section
        id="tutorial"
        className="section-tutorial no-gutter"
        innerRef={this.$el}
      >
        <div className="bg-ib bg-m-none mmt3">
          <Container>
            <Row className="">
              <Col>
                <SectionHeader className="color-bluegreen">
                  {copy && copy.service_title}
                </SectionHeader>
              </Col>
            </Row>
            <Row>
              <Col
                className="center mt4 mmt1"
                sm={8}
                md={3}
                offset={{ sm: 2, md: 3 / 4 }}
              >
                <Hidden xs sm>
                  <img className="mb3" src={SVG_Icon_1} width={96} alt="" />
                </Hidden>
                <h3 className="h5 my3 mmb1 color-navy font-regular line-height-4">
                  {copy ? copy.service_steps[0].title : ""}
                </h3>
                <p className="body line-height-5 color-bg">
                  Egal ob Tages- oder Monatslinsen - wir haben die passende
                  Linse für dich. Unser <Link to="/wizard">Online-Berater</Link>{" "}
                  unterstützt dich gerne bei der Auswahl des richtigen Produkts.
                </p>
              </Col>
              {renderServiceStep({
                icon: SVG_Icon_2,
                ...(copy ? copy.service_steps[1] : {}),
              })}
              {renderServiceStep({
                icon: SVG_Icon_3,
                ...(copy ? copy.service_steps[2] : {}),
              })}
            </Row>
            <Row className="mb4">
              <Col>
                <br />
                <br />
              </Col>
            </Row>
          </Container>
        </div>
        <Hidden xs sm>
          <Container fluid className="my2">
            <Row>
              <Col>
                <img src={IMG_MOOD} alt="" className="fit w-100" />
              </Col>
            </Row>
          </Container>
          <div className="pt2">
            <Container>
              <Row nogutter className="mb3 pb1">
                <Col>
                  <SectionHeader className="color-bluegreen">
                    {copy && copy.usage_title}
                  </SectionHeader>
                </Col>
              </Row>
              <Row nogutter>
                <Col md={6} className="overflow-visible">
                  <Carousel
                    contentEnabled={true}
                    images={[STEP_1video, STEP_2video, STEP_3video]}
                    poster={[STEP_1fallback, STEP_2fallback, STEP_3fallback]}
                  />
                </Col>
                <Col md={0.5}>&nbsp;</Col>
                <Col md={5} className="flex items-center">
                  <ol className={`ml4 mr5`}>
                    {copy && renderUsageSteps(copy.usage_steps)}
                  </ol>
                </Col>
              </Row>
              <Row>
                <Hidden md>
                  <div id="foo">
                    <br />
                    <br />
                    <br />
                  </div>
                </Hidden>
              </Row>
            </Container>
          </div>
        </Hidden>
      </Section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Home/SectionTutorial.js